import { Outlet, useLocation } from 'react-router-dom'

import { observer } from 'mobx-react'

import { useEffect } from 'modules/core/hooks/useEffect'
import { track, trackingEvents } from 'modules/core/lib/Tracking'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

export interface InboxOutletContext {}

const InboxPage = () => {
  const { pathname } = useLocation()

  const isCompletedTasksPage = pathname.includes('/completed')
  const isTodoTasksPage = pathname.includes('/todo')
  const isRequestsPage = pathname.includes('/requests')

  const isFullscreen = isCompletedTasksPage || isTodoTasksPage || isRequestsPage

  useEffect(() => {
    track(trackingEvents.inbox.opened)
  }, [])

  return (
    <ResponsivePage.Body variant={isFullscreen ? 'fullscreen' : 'full'}>
      <Outlet />
    </ResponsivePage.Body>
  )
}

export default observer(InboxPage)
